// extracted by mini-css-extract-plugin
export default {"localShareLayout":"localshare_localShareLayout__dbODC","videoPlayer":"localshare_videoPlayer__Gg4TH"};